import script from "./fieldLabel.vue?vue&type=script&lang=js"
export * from "./fieldLabel.vue?vue&type=script&lang=js"

import "./fieldLabel.vue?vue&type=style&index=0&id=25df6035&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__file',"src/components/cmp/cForm/fields/core/fieldLabel.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "25df6035"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('25df6035', __exports__)) {
    api.reload('25df6035', __exports__)
  }
  
}


export default __exports__